import { Ref, forwardRef } from 'react';

import clsx from 'clsx';

import { Button } from '@/common/styleguide/atoms/Button/Button';
import CurrentEventTile from '@/modules/HomePage/components/CurrentEvents/CurrentEventTile';
import { HomepageCurrentEvent } from 'generatedBfw/static';

import styles from './currentEvents.module.scss';
interface Props {
  events: HomepageCurrentEvent[];
  handleShowMore: () => void;
  amountToReveal: number;
  setEventTileHeight: (height: number) => void;
  listHeight: number | string;
  isButtonHidden: boolean;
  isBrowser?: boolean;
}

const CurrentEventsView = (
  {
    events,
    handleShowMore,
    amountToReveal,
    setEventTileHeight,
    isButtonHidden,
    listHeight,
    isBrowser,
  }: Props,
  listRef: Ref<HTMLUListElement>,
) => (
  <div className={styles.container} data-testid="current-events">
    <ul
      className={styles.list}
      data-testid="current-events-list"
      ref={listRef}
      style={{ maxHeight: listHeight }}
    >
      {events.map((event, index) => (
        <CurrentEventTile
          className={clsx(styles.listItem, { [styles.listItemShown]: isBrowser })}
          event={event}
          index={index}
          isLazyLoaded={index > 2} // no lazy loading for the first 3 events
          key={event.id}
          setElementHeight={index === 0 ? setEventTileHeight : undefined}
        />
      ))}
    </ul>
    {!isButtonHidden ? (
      <Button className={styles.button} onClick={handleShowMore} variant="secondary">
        Show {amountToReveal} more
      </Button>
    ) : null}
  </div>
);

export default forwardRef(CurrentEventsView);
